<template>
    <div class="task-aperte-page">

        <div id="choose-trello-user" class="step">

            <h2>Scegli un membro di Trello.</h2>

            <MemberSelect/>

        </div>

        <div id="tasks-output" class="step">

            <OpenCards/>

        </div>

    </div>

</template>

<script>
import MemberSelect from '@/components/MemberSelect.vue'
import OpenCards from '@/components/OpenCards.vue'

export default {
    name: 'task-aperte',
    components: {
        MemberSelect,
        OpenCards,
    },
}
</script>
